<mat-toolbar class="header-toolbar">
  <div class="header-content">
    <!-- Logo -->
    <div class="logo-section">
      <mat-icon>business</mat-icon>
      <div class="logo-text-container">
        <div class="company-name">Babylon Financial Group Zrt.</div>
        <div class="system-name">CRM Rendszer</div>
      </div>
    </div>
    
    <!-- System Info - Center -->
    @if (systemInfo) {
      <div class="system-info-section">
        <div class="info-item" [matTooltip]="'Teljes verzió: ' + appVersion.full">
          <mat-icon class="info-icon">verified</mat-icon>
          <div class="info-content">
            <span class="info-label">Verzió</span>
            <span class="info-value">{{ appVersion.short }} ({{ appVersion.commitHash }})</span>
          </div>
        </div>
        
        <mat-divider [vertical]="true" class="info-divider"></mat-divider>
        
        <div class="info-item" [matTooltip]="'Frontend utolsó deploy: ' + (systemInfo.frontend_deploy_time !== 'N/A' ? formatDeployTime(systemInfo.frontend_deploy_time) : 'N/A')">
          <mat-icon class="info-icon">cloud_upload</mat-icon>
          <div class="info-content">
            <span class="info-label">Deploy</span>
            <span class="info-value">{{ systemInfo.frontend_deploy_time !== 'N/A' ? formatDeployTime(systemInfo.frontend_deploy_time) : 'N/A' }}</span>
          </div>
        </div>
        
        <mat-divider [vertical]="true" class="info-divider"></mat-divider>
        
        <div class="info-item" [matTooltip]="'Adatbázis: ' + systemInfo.database_name">
          <mat-icon class="info-icon">storage</mat-icon>
          <div class="info-content">
            <span class="info-label">Adatbázis</span>
            <span class="info-value environment-badge" [style.background-color]="getEnvironmentColor()">
              {{ getShortDatabaseName() }}
            </span>
          </div>
        </div>
      </div>
    }
    
    <!-- Notifications Bell -->
    <div class="notification-section">
      <button mat-icon-button
              #notificationTrigger="matMenuTrigger"
              [matMenuTriggerFor]="notificationMenu"
              class="notification-bell-button"
              matTooltip="Emlékeztetők">
        <mat-icon [matBadge]="pendingCount() > 0 ? pendingCount() : null"
                  matBadgeColor="warn"
                  matBadgeSize="small"
                  aria-hidden="false"
                  [class.bell-shake]="bellShaking()">
          notifications
        </mat-icon>
      </button>
      <mat-menu #notificationMenu="matMenu">
        <div class="notification-menu-wrapper" (click)="$event.stopPropagation()">
          <div class="notification-header">
            <mat-icon>notifications_active</mat-icon>
            <span>Emlékeztetők</span>
          </div>
          <mat-divider></mat-divider>
          @if (pendingReminders().length === 0) {
            <div class="notification-empty">
              <mat-icon>notifications_off</mat-icon>
              <span>Nincs esedékes emlékeztető</span>
            </div>
          } @else {
            @for (reminder of pendingReminders(); track reminder.id) {
              <div class="notification-item" (click)="onReminderClick(reminder)">
                <div class="notification-item-content">
                  <div class="notification-item-title">{{ reminder.title }}</div>
                  <div class="notification-item-meta">
                    <mat-icon class="meta-icon">schedule</mat-icon>
                    {{ formatReminderTime(reminder.reminder_time) }}
                  </div>
                  @if (reminder.notes) {
                    <div class="notification-item-notes">{{ reminder.notes }}</div>
                  }
                </div>
                <div class="notification-item-actions">
                  <button mat-icon-button
                          (click)="onReminderComplete(reminder, $event)"
                          matTooltip="Kész"
                          class="action-complete">
                    <mat-icon>check_circle</mat-icon>
                  </button>
                </div>
              </div>
            }
          }
        </div>
      </mat-menu>
    </div>

    <!-- User Actions - Right -->
    <div class="header-user-section">
      <div class="header-user-info">
        <div class="header-user-text">
          <span class="header-user-name">{{ currentUser?.username || 'Felhasználó' }}</span>
          <span class="header-user-role">{{ currentUser?.jobNames?.join(', ') || 'Munkatárs' }}</span>
        </div>
        <button mat-icon-button [matMenuTriggerFor]="userMenu" class="header-profile-button">
          <mat-icon>{{ getUserIcon() }}</mat-icon>
        </button>
      </div>
      <mat-menu #userMenu="matMenu">
        <button mat-menu-item (click)="onProfile()">
          <mat-icon>person</mat-icon>
          <span>Profilom</span>
        </button>
        <mat-divider></mat-divider>
        <button mat-menu-item (click)="onLogout()">
          <mat-icon>logout</mat-icon>
          <span>Kijelentkezés</span>
        </button>
      </mat-menu>
    </div>
  </div>
</mat-toolbar>

<!-- Emlékeztető toast értesítések - jobb felső sarok -->
@if (visibleToasts().length > 0) {
  <div class="reminder-toast-container">
    @for (toast of visibleToasts(); track toast.id) {
      <div class="reminder-toast">
        <mat-icon class="toast-icon">notifications_active</mat-icon>
        <span class="toast-text">Visszahívás: {{ toast.displayName }}</span>
        <button mat-button class="toast-dismiss" (click)="dismissToast(toast.id)">Ok</button>
      </div>
    }
  </div>
}
